<template>
  <div>
    <div>
      <div class="form-group">
        <label>Department</label>
        <el-select class="select"
                   size="large"
                   placeholder="Department"
                   v-model="departmentId">
          <el-option v-for="option in allDepartments"
                     class="select"
                     :value="option.value"
                     :label="option.label"
                     :key="option.label">
          </el-option>
        </el-select>
      </div>
      <h6 id="heading-deployment-files">Deployment File(s) (.bpmn)</h6>

      <input type="file" id="attachments" multiple="multiple" accept=".bpmn">

      <div class="row">
        <div class="col-md-6" style="padding-top: 34px;">
          <div v-if="isSaving" style="text-align: right;">
            <img src="static/img/loading-2.gif" width="30px" height="30px" />
          </div>
          <div v-if="isSuccess" style="text-align: right;">
            <img src="static/img/active-true.png" width="30px" height="30px" />
          </div>
          <div v-if="isFailed" style="text-align: right;">
            <img src="static/img/active-error.png" width="30px" height="30px" />
          </div>
        </div>
        <div class="col-md-6">
          <div id="btn-submit">
            <button @click="validateAndSubmit" class="btn btn-fill btn-info btn-wd btn-save pull-right" :disabled="isSaving">Save Deployment</button>
          </div>
        </div>
      </div>
    </div>
    <div style="clear:both"></div>
  </div>
</template>

<script>
  import {notifySuccess, notifyError} from 'src/utilities/utils'
  import {mapGetters} from 'vuex'
  import Constants from 'src/utilities/constants'

  const STATUS_INITIAL = 0
  const STATUS_SAVING = 1
  const STATUS_SUCCESS = 2
  const STATUS_FAILED = 3

  export default {
    props: ['data'],
    computed: {
      ...mapGetters({
        allDepartments: 'departments/kvpsForSelect'
      }),
      isInitial() {
        return this.currentStatus === STATUS_INITIAL
      },
      isSaving() {
        return this.currentStatus === STATUS_SAVING
      },
      isSuccess() {
        return this.currentStatus === STATUS_SUCCESS
      },
      isFailed() {
        return this.currentStatus === STATUS_FAILED
      }
    },
    data () {
      return {
        departmentId: null,
        currentStatus: null,
      }
    },
    methods: {
      async validateAndSubmit () {
        this.currentStatus = STATUS_SAVING
        if (await this.$validator.validateAll()) {
          let filesUploadInput = document.querySelector('#attachments')
          const response = await this.$store.dispatch('camunda/create/deploy', {
            departmentId: this.departmentId,
            files: filesUploadInput.files
          })

          if (response.result === Constants.RETURN_CODES.SUCCESS) {
            this.clearCache()
            notifySuccess(this, 'Camunda Deployment Created Successfully')
            this.currentStatus = STATUS_SUCCESS
            this.$emit('close')
          } else {
            notifyError(this, 'Failed to create Camunda Deployment(s)', response.errors)
            this.currentStatus = STATUS_FAILED
          }
        }
      },
      getError(fieldName) {
        return this.errors.first(fieldName)
      },
      clearCache() {
        // purge the camunda deployments cache after a deployment has been added
        if (this.$store.cache.has('camunda/fetchAllPtracDeployments')) {
          this.$store.cache.delete('camunda/fetchAllPtracDeployments')
        }
      }
    },
    mounted() {
      this.currentStatus = STATUS_INITIAL
      this.departmentId = this.data.id
    }
  }
</script>

<style scoped>
  #heading-deployment-files {
    margin-top: 20px;
  }
  #btn-submit {
    margin-top: 20px
  }
</style>
